export const REPORT_ACTIONS = [
  {
    action: 'exportActionListReports',
    title: 'Overall Metrics Report',
    description:
      'This report lists key metrics on unplanned downtime and cost savings for the current month and YTD. It highlights assets with recurring action items, their status, associated facilities, and the operational impact. The report supports high-level visibility into asset performance and maintenance efficiency.',
    btnText: 'Download',
    toPage: '',
     datarangeTitle: 'Overall Metrics Date Range',
    icon: 'overall-metrics-report',
    locationsType: 'array',
    fileFormat: {
      type: 'application/pdf',
      downloadFormat: 'pdf',
    },
    extraFileFormat: {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      downloadFormat: 'xlsx',
    },
  },
  {
    action: 'exportEquipmentFailureReport',
    title: 'Recurring Action Item Report',
    description:
      'This report lists all of the monitored points that have had at least one Action Item since the monitoring system was implemented and includes a tally of Action Items raised against each monitored point. The monitored points with the highest number of action items are displayed at the top of the list.',
    btnText: 'Download',
    datarangeTitle: 'Action Item Creation Date Range',
    toPage: '',
    icon: 'failure-report',
    locationsType: 'array',
    fileFormat: {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      downloadFormat: 'xlsx',
    },
    aiTypeFilter: true,
  },
  {
    action: 'exportEquipmentReport',
    title: 'Equipment List',
    description:
      'This download includes information on the structure of the facility, offering two potential levels of detail. It can either provide a detailed breakdown of the equipment or be organized to focus on specific installation points within the facility.',
    btnText: 'Download',
    datarangeTitle: '',
    toPage: '',
    byStructureTitle: 'REPORT SHOULD CONTAINS A LIST OF',
    modalDescription: 'Please select the details below, and then click Download.',
    icon: 'site-monitoring-report',
    locationsType: 'array',
    fileFormat: {
      type: 'application/csv',
      downloadFormat: 'csv',
    },
  },
  {
    action: 'exportActiveActionItems',
    title: 'Open Action Items',
    description:
      'This download includes all monitored points that have an open action item or are on the Waites Analyst Watchlist. Waites Analysts closely monitor watchlist points and determine whether they should be upgraded to action items.',
    btnText: 'Download',
    showWatchlist: true,
    datarangeTitle: 'Action Item Creation Date Range',
    toPage: '',
    icon: 'ai-report',
    locationsType: 'string',
    fileFormat: {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      downloadFormat: 'xlsx',
    },
    aiTypeFilter: true,
    showCheckbox: true,
    checkboxLabel: 'Include closed Action Items',
  },
  {
    action: 'exportCostSavings',
    title: 'Cost Savings Report',
    description:
      'This report lists all Action Items (including those in the archive) at your facility that have an associated cost savings.',
    btnText: 'Download',
    datarangeTitle: 'Associated Cost Savings Data Range',
    toPage: '',
    icon: 'cost-savings-report',
    locationsType: 'array',
    fileFormat: {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      downloadFormat: 'xlsx',
    },
    showCheckbox: true,
    checkboxLabel: 'Include any items where maintenance was performed (but may not have cost savings)',
  },
  {
    action: 'archiveActionItems',
    title: 'Archived Action Items',
    description: 'Access archived Action Items, apply filters, and download the results in a .csv file.',
    btnText: 'Build Report',
    datarangeTitle: undefined,
    toPage: 'archive',
    icon: 'archived-ai-report',
    locationsType: 'string',
    fileFormat: {
      type: 'application/csv',
      downloadFormat: 'csv',
    },
  },
  {
    action: 'exportPercentage',
    title: 'Site Engagement Report',
    description:
      'Access site engagement metrics for action items, apply filters, and download the results in a .csv file.',
    btnText: 'Build Report',
    datarangeTitle: undefined,
    toPage: 'site-engagement',
    icon: 'site-engagement-report',
    locationsType: 'string',
    fileFormat: {
      type: 'application/csv',
      downloadFormat: 'csv',
    },
  },
  {
    action: 'hardwareOverview',
    title: 'Hardware Overview Report',
    description:
      'This download includes a full list of all Waites hardware by facility from the Hardware overview page of the Full-Service Dashboard.',
    btnText: 'Download',
    datarangeTitle: undefined,
    toPage: '',
    icon: 'hardware-overview-report',
    locationsType: 'array',
    fileFormat: {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      downloadFormat: 'xlsx',
    },
  },
  {
    action: 'userList',
    title: 'User List',
    description: 'List of all users with their accesses, and roles.',
    btnText: 'Download',
    datarangeTitle: undefined,
    toPage: '',
    icon: 'user-list',
    locationsType: 'array',
    fileFormat: {
      type: 'application/csv',
      downloadFormat: 'csv',
    },
  },
];
